import React, { useState, useEffect } from "react";
import SsoHeader from "../../components/uikit/src/components/SsoHeader";
import SsoFooter from "../../components/uikit/src/components/SsoFooter";
// import CompanyLogo from "../../assets/images/navigator-logo.png";
import CompanyLogo from "../../assets/images/navigatorai-logo.svg";
import EmailQueryImg from "../../assets/images/email-query-img.png";

import QuestionMarkIcon from "../../assets/images/question-octagon.svg";
import NotificationIcon from "../../assets/images/notification-outline-badged.svg";
import LogoutIcon from "../../assets/images/Logout.svg";
import UserIcon from "../../assets/images/User.svg";

import CardSlider from "./CardSlider.jsx";
import NavCardLayout from "./NavCardLayout.jsx";
import EmailQueryLayout from "./EmailQueryLayout.jsx";
import { Link as ScrollLink, Element as ScrollElement } from "react-scroll";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";

import { applicationMap, CardContainerHead, CardsListing } from "../../constants";

import { Navigate, useNavigate } from "react-router-dom";
import AuthService, { FetchUsers, getMyDetails, tokenValidationApi } from "../../services/AuthService";
import config from "../../services/config.js";
import NotPermitionModal from "./NotPermitionModal.jsx";
import { useUser } from "../../context/UserContext.js";

export default function LandingPage() {
  const [notPermitionModalIcon, setNotPermitionModalIcon] = useState("");
  const [notPermitionModalHeading, setNotPermitionModalHeading] = useState('');
  const [notPermitionModalOpen, setNotPermitionModalOpen] = useState(false);
  const [showScrollButton, setShowScrollButton] = useState(false);
  const { setUserEmail,setuserName,userName,userEmail ,apps,setApps} = useUser();
  const navigate = useNavigate();
 
  const handleNavigation = async (navigationPath, application) => {
    let app = '';
    if (application === 'Indication') {
      app = 'ipt';
    } else if (application === 'Asset') {
      app = 'apt';
    } else if (application === 'Clarity') {
      app = 'voc';
    } else if (application === 'Survey') {
      app = 'quant';
    } else if (application === 'Launch') {
      app = 'launch_nav';
    }

    if (navigationPath === "#") {
      navigate(navigationPath);
    } else {
      try {
        await config.post(
          "/api/user-track",
          { email: userEmail, application: app }
        );
        window.location.replace(navigationPath);
      } catch (error) {
        
      }
      
    }
  };
  const HandleLogout = async () => {
    await AuthService.Logout(userEmail);
    // removeCookie(`inizionavigator`, {
    //   path: "/",
    //   domain: process.env.REACT_APP_COOKIE_DOMAIN,
    // });
    navigate("/login");
  };

  useEffect(() => {
     const getMyDetailsFunction=async()=>{
      try {
        const response = await getMyDetails();

        setUserEmail(response.email);
        setuserName(response.name);
        setApps(response.apps);
      } catch (error) {
        
      }
    }
    getMyDetailsFunction();

   
  }, []);

  // #START: Scroll to ID and down to top section
  // Scroll button active after scroll
  const handleScroll = () => {
    const scrollPosition = window.scrollY;
    // Change 200 to the number of pixels at which you want to show the button
    if (scrollPosition > 200) {
      setShowScrollButton(true);
    } else {
      setShowScrollButton(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  // #END: Scroll to ID and down to top section



  const handleNotPermitionModalClose = () => {
    setNotPermitionModalOpen(false);
  };

  const handleNotPermitionModalOpen = (heading,icon) => {
    setNotPermitionModalIcon(icon);
    setNotPermitionModalHeading(heading);
    setNotPermitionModalOpen(true);
  };

  return (
    <>

      <NotPermitionModal open={notPermitionModalOpen} notPermitionModalIcon={notPermitionModalIcon} notPermitionModalHeading={notPermitionModalHeading} onClose={handleNotPermitionModalClose} />
      <ScrollElement name="header" className="element">
        <SsoHeader
          iconsList={[QuestionMarkIcon, NotificationIcon]}
          logoutIcon={LogoutIcon}
          UserIcons={UserIcon}
          logo={CompanyLogo}
          useremail={userEmail}
          username={userName}
          logoutCallback={HandleLogout}
        />
      </ScrollElement>

      <div className="about-container">
        <div className="container hgt-inherit">
          <div className="row hgt-inherit">
            <div className="col-sm-12 col-md-12 col-lg-5 col-xl-5 col-xxl-6 hgt-inherit">
              <section className="hp-banner-text hgt-inherit">
                <p className="fade-in wc-ttl">Hey {userName} !</p>
                <div className="wc-mg-text">
                  <span>Welcome to</span>
                  <span>Navigator.ai</span>
                </div>
                <p className="fade-in delayed wc-data-text">
                  InizioNavigator.ai is a data platform built using latest
                  technology to house a real-time <span>“Data Universe”.</span>
                </p>
              </section>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-7 col-xl-7 col-xxl-6 d-flex align-items-center justify-content-center">
              <div className="wc-banner-img-section">
                <div className="slider-thumb-up"></div>
                <div className="slider-thumb-down"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ScrollElement name="newUpdates" className="element">
        <div className="card-slider-section">
          <h2>New Updates</h2>
          <CardSlider />
        </div>
      </ScrollElement>

      <ScrollElement name="ourSolutions" className="element">
        <div className="card-container">
          <h2>{CardContainerHead}</h2>
          <div className="card-box-center-align">
            <div className="row align-items-start">
              {CardsListing.slice(0, 5).map((car) => (
                <div
                  className="col-xs-12 col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3"
                  onClick={() => apps[applicationMap[car.props.cardDetails.heading]] ?
                    handleNavigation(
                      car.navigationPath,
                      car.props.cardDetails.heading
                    ) : handleNotPermitionModalOpen(car.props.cardDetails.heading, car.props.cardDetails.imageUrl)
                  }
                >
                  <NavCardLayout cardProps={car.props} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </ScrollElement>
      <ScrollElement name="contactUs" className="element">
        <div className="email-query-container">
          <div className="email-sec">
            <div className="email-qus-img-wd">
              <img
                src={EmailQueryImg}
                className="img-fluid"
                alt="email-query"
              />
            </div>
            <div className="d-flex flex-column email-section">
              <div className="help-corner">Help &amp; Suggestion Corner </div>
              <div className="any-questions">
                Got Any Question or Suggestion
              </div>
              <div className="ask-text">
                Let us know your questions or drop a suggestion as well.{" "}
              </div>
              <EmailQueryLayout />
            </div>
          </div>
        </div>
      </ScrollElement>
      <SsoFooter />

      {showScrollButton && (
        <div className="scroll-up-arrow" onClick={scrollToTop}>
          <div className="up-arrow-bg">
            <ArrowUpwardIcon style={{ color: "#fff" }} />
          </div>
        </div>
      )}
    </>
  );
}
